import { Component, OnInit, signal, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@classi/spen';
import { Location } from '@angular/common';

import { SpaceService } from '../../space.service';
import { Space } from '../../space';
import { SlideMenuService } from '@services/slide-menu.service';
import { GoogleAnalytics4Service } from '@services/google-analytics-4.service';
import { isMobileApp } from '@functions/browser';

import { environment } from '@environments/environment';

@Component({
  selector: 'app-spaces-list-student',
  templateUrl: './spaces-list-student.component.html',
  styleUrls: ['./spaces-list-student.component.scss'],
  standalone: false,
})
export class SpacesListStudentComponent implements OnInit {
  private spaceService = inject(SpaceService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private location = inject(Location);
  private googleAnalytics4Service = inject(GoogleAnalytics4Service);
  private slideMenuService = inject(SlideMenuService);

  spaces: Array<Space>;
  dataLoaded = false;
  readonly classiUrl = environment.platformUrl;
  paginationLoaded = false;
  errorMsg: string;
  readonly page = signal({
    per_page: 1,
    current_page: 1,
    total_pages: 1,
    total_count: 0,
  });

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const pageIndex = +params['page'] || 1;
      this.getSpacesList({ page: pageIndex });
    });
  }

  getSpacesList(params: Object) {
    this.spaceService.getStudentSpacesList(params).subscribe(
      (response) => {
        this.spaces = response['spaces'];
        this.page.set({ ...this.page(), ...response['pages'] });
        this.dataLoaded = true;
        if (this.spaces.length > 0) {
          this.paginationLoaded = true;
        }
      },
      (error) => {
        this.errorMsg = <any>error;
        this.spaces = [];
      },
    );
  }

  get spacesCount() {
    return this.spaces.length;
  }

  get showPagination(): boolean {
    return this.paginationLoaded && this.page().total_pages > 1;
  }

  pageChanged({ index }: PageEvent) {
    this.router.navigate(['.'], {
      queryParams: { page: index + 1 },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
      replaceUrl: true,
    });
    window.scrollTo(0, 0);
  }

  slideMenu() {
    this.slideMenuService.slideIn();
  }

  sendNewDocumentGAEvent() {
    this.googleAnalytics4Service.sendEvent('スペース', '一覧画面', '活動記録作成');
  }

  get isMobileApp() {
    return isMobileApp();
  }
}
